import React from 'react';
import PropTypes from 'prop-types';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { REDIRECTIONS } from '@sm360/widget-commons-general';
import GarageCashPurchase from 'commons-garage/components/GarageCashPurchase/GarageCashPurchase.jsx';
import GarageFinance from 'commons-garage/components/GarageFinance/GarageFinance.jsx';
import 'commons-garage/components/GarageVehicle/VehiclePayments/VehiclePayments.scss';

const VehiclePayments = ({ quote, vehicle }) => {
    const isCarAvailable = vehicle.isAvailable();
    const isQuoteInPendingStatus = quote.isQuoteInPending();
    const isQuoteInApprovalStatus = quote.isQuoteInApproval();
    const isCashPurchase = !quote.vehicle.purchaseMethods.getSelectedFinance();
    const vdpRedirectionUrl = quote.getVehicleRedirectionFromQuote();

    const isQuoteWithDeposit = !isQuoteInPendingStatus && isCarAvailable && !isQuoteInApprovalStatus;
    const isQuoteWithoutDeposit = isQuoteInPendingStatus && !isQuoteInApprovalStatus;
    const isQuoteExpired = !isQuoteInApprovalStatus && !isQuoteInPendingStatus && !isCarAvailable;

    const renderedContent = [];
    let ctaButton = null;
    let checkoutRedirectionUrl = '';

    if (isQuoteWithDeposit) {
        ctaButton = (
            <a href={vdpRedirectionUrl} className="sr-button-1 is-small">
                {LocaleService.t('GARAGE.VEHICLE_STATUS.SELECT')}
            </a>
        );

        if (isCashPurchase) {
            renderedContent.push(<GarageCashPurchase quote={quote} />, ctaButton);
        } else {
            renderedContent.push(<GarageFinance quote={quote} />, ctaButton);
        }
    } else if (isQuoteWithoutDeposit) {
        checkoutRedirectionUrl = `${REDIRECTIONS[LocaleService.getSimpleLocale()].checkout}?quoteId=${quote.id}`;
        ctaButton = (
            <a href={checkoutRedirectionUrl} className="sr-button-1 is-small is-right">
                {LocaleService.t('GARAGE.VEHICLE_STATUS.FINALIZE')}
            </a>
        );

        // We need to push an empty span, since the layout is flexed with justify-content: space-between.
        renderedContent.push(<span />, ctaButton);
    } else if (isQuoteExpired) {
        renderedContent.push(<span className="is-price">{LocaleService.t('GARAGE.UNAVAILABLE')}</span>);
    }

    return <div className="garage-vehicle-payments">{renderedContent}</div>;
};

VehiclePayments.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
};

VehiclePayments.displayName = 'VehiclePayments';

export default VehiclePayments;



// WEBPACK FOOTER //
// ./src/components/GarageVehicle/VehiclePayments/VehiclePayments.jsx